<template>
  <div class="restRoomOrder full-height linear-main3">
    <ld-header
      @click-left="$router.push({path:'/allOrder?findType=1'})"
      transparent
      white
    >
      <div class="font12">
        订单号：{{ detail.orderNo }} {{ detail.tripType==1?'公':'私' }}
      </div>
    </ld-header>

    <div class="wrapper">
      <mescroll-vue
        ref="mescroll"
        :down="{use:false}"
      >
        <div class="mainbox">
          <div class="box">
            <div class="white list">
              <div class="font24 font-lg box">
                {{ detail.orderStatus|orderStatus }}<span v-show="detail.orderStatus!=5"> | {{ detail.payStatus==0?'待支付':'已支付' }} </span> <span v-show="detail.usageStatus"> | {{ detail.usageStatus|usageStatus }}</span>
              </div>
              <van-row
                v-show="detail.isAutoCancle"
                type="flex"
                align="center"
              >
                <van-col span="7">
                  支付时限剩余：
                </van-col>
                <van-col span="10">
                  <van-count-down
                    ref="countDown"
                    style="color:red;font-size:16px"
                    :time="times"
                    @finish="getDetail"
                    format=" HH 时 mm 分 ss 秒"
                  />
                </van-col>
              </van-row>
              <div>预订人：{{ detail.bookerName }}</div>
              <div>预订时间：{{ detail.bookDate }}</div>
              <div v-show="detail.payStatus==1">
                <div>支付时间：{{ detail.payDate }} {{ detail.payMothedName }}</div>
              </div>
            </div>
          </div>

          <div>
            <van-cell>
              <van-row>
                <van-col span="12">
                  <span class="font-bold">休息室</span>
                </van-col>
                <van-col
                  span="12"
                  class="text-right main-color"
                  @click="$dialog.alert({
                    title:'服务介绍',
                    messageAlign:'left',
                    message:detail.productDesc.split('\n').join('</br>')
                  })"
                >
                  服务介绍
                </van-col>
              </van-row>
            </van-cell>
            <van-cell>
              <van-row
                gutter="16"
                type="flex"
                align="center"
              >
                <van-col span="8">
                  <van-image
                    :src="detail.faceImg"
                    radius="8"
                    show-loading
                    style="min-width:80px;min-height:80px;"
                  >
                    <template v-slot:loading>
                      <van-loading
                        type="spinner"
                        size="20"
                      />
                    </template>
                    <!-- <template v-slot:error>
                lazy-load
                show-error
                  加载失败
                </template> -->
                  </van-image>
                </van-col>
                <van-col span="16">
                  <div class="font-md">
                    {{ detail.productName }}
                  </div>
                  <!-- <van-rate
              v-model="value"
              allow-half
              readonly
              :size="14"
              color="#ffd21e"
              void-icon="star"
              void-color="#eee"
            />
            <span>  2.5 </span> -->
                  <div class="gray font12">
                    {{ detail.terminal }}航站楼 {{ detail.securityCheck==1?'安检后':'安检前' }}
                  </div>
                </van-col>
              </van-row>
            </van-cell>
            <van-cell
              icon="location-o"
              class="font12"
            >
              {{ detail.loungeAddress }}
            </van-cell>
            <div class="box">
              <van-field
                label="使用人次"
                readonly
              >
                <template #input>
                  {{ detail.personTime }}人次
                </template>
              </van-field>
            </div>

            <div
              v-show="detail.usageStatus>0"
              class="box"
            >
              <van-cell
                v-for="(item,index) in detail.obtAirportServerOrderPsgBeanList"
                is-link
                :key="index"
                :title="`券号： ${item.couponNo||''}`"
                value="查看二维码"
                @click="showQr(index)"
              />
            </div>
          </div>

          <div
            class="box"
            v-if="detail.orderStatus==3||detail.orderStatus==4"
          >
            <van-field
              label="有效期"
              readonly
            >
              <template #input>
                {{ detail.validityStart }}至{{ detail.validityEnd }}
              </template>
            </van-field>
            <van-field
              label="用户提示"
              readonly
              autosize
              type="textarea"
            >
              <template
                #input
                class="font12"
              >
                {{ detail.userTips }}
              </template>
            </van-field>
          </div>
          <!--  -->
          <travel-info
            ref="travelinfo"
            :travel-data="detail"
            :details="true"
          />
        </div>
      </mescroll-vue>
    </div>
    <!-- 底部导航 -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
    >
      <van-row
        type="flex"
        align="center"
        gutter="16"
        justify="space-between"
        class="bg-white full-width shadow list"
      >
        <van-col span="8">
          <span class="font12 money-color">&yen;</span><span
            class="font22 money-color"
          >{{ detail.totalAmount }} </span>
          <!-- <span class="font10 gray">{{ $t('E017','共') }}{{ travelerList.length }}人</span> -->
        </van-col>
        <!-- <van-col span="8">
          <div
            class="font12 text-left"
            @click="toggle('tabbar')"
          >
            <span>{{ $t('E006','明细') }}</span>
            <van-icon
              name="arrow-up"
              class="vertical-middle"
              size="14"
            />
          </div>
        </van-col> -->
        <van-col
          span="8"
        >
          <ld-button
            :loading="false"
            v-show="detail.orderStatus<3&&detail.payStatus==0"
            size="md"
            defaults
            @click.native="cancel"
          >
            取消
          </ld-button>
        </van-col>
        <van-col
          span="8"
        >
          <ld-button
            :loading="false"
            v-show="detail.payStatus==0&&detail.orderStatus<3"
            size="md"
            main
            @click.native="pay"
          >
            去支付
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>


    <!--  -->
    <van-popup
      :lock-scroll="true"
      class="popup-width"
      closeable
      v-model="isShowQr"
      :close-on-popstate="true"
    >
      <van-cell>休息室</van-cell>
      <van-cell>
        <div class="text-center">
          {{ detail.cityName }}- {{ detail.productName }}
        </div>
        <div class="text-center">
          <van-image
            width="250"
            height="250"
            lazy-load
            :src="qrInfo.couponImg"
            alt="二维码"
          />
        </div>
        <div class="text-center">
          {{ detail.usageStatus|usageStatus }}
        </div>
      </van-cell>
      <van-cell
        icon="location-o"
        class="font12"
      >
        {{ detail.loungeAddress }}
      </van-cell>
    </van-popup>
  </div>
</template>

<script>
import {Field,Cell,Stepper,Popup, Image as VanImage,loading,CountDown} from 'vant'
import { mapGetters } from 'vuex'
import { formatDate ,getDiffMinutes,getPreStrTime} from 'Utils/dateUtil'
// import tripType from 'Common/tripType'
// import ldEditLinker from 'Components/ldEditLinker'
// import traver from 'Components/tk/traver'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import travelInfo from 'Components/travelInfo'

export default {
  name: 'RestRoomOrder',
  components:{
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Stepper.name]: Stepper,
    [Popup.name]: Popup,
    [CountDown.name]: CountDown,
    [loading.name]: loading,
    [VanImage.name]: VanImage,
    ldTabbar,
    ldButton,
    // traver,
    travelInfo,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),

  },
  data () {
    return {
      pnum:1,
      flightNo:'',
      departDate:'123',
      priceList: [],
      showExpiryDate: false,
      expiryDate: new Date(),
      linker:{},
      detail:{
        obtAirportServerOrderPsgBeanList:[]
      },
      isShowQr:false,
      qrInfo:{},
      orderId:'',
      times:60*60*1000
    }
  },
  computed: {
    ...mapGetters({
      userInfo:'userInfo',
      sysType:'sysType',
      // travelerList: 'checkIn/travelerList',
    }),
    // priceList(){
    // 	let adult= {name:'成人',price:'',amount:0,unit:'人'},
    // 		child={name:'儿童',price:'',amount:0,unit:'人'},
    // 		baby={name:'婴儿',price:'',amount:0,unit:'人'},
    // 		arr=[],first={},
    // 		cxr=this.details.orderPsgBeanList
    // 	if(cxr.length>0){
    // 		cxr.forEach((item) =>{
    // 			if(item.psgType==1){
    // 				adult.amount+=1
    // 				adult.price=item.salePrice+item.airportFee+item.tax+item.serviceFee+(this.details.bxPrice?this.details.bxPrice/cxr.length:0)
    // 				first=item
    // 			}else if(item.psgType==2){
    // 				child.amount+=1
    // 				child.price=item.salePrice+item.airportFee+item.tax+item.serviceFee+(this.details.bxPrice?this.details.bxPrice/cxr.length:0)
    // 			}else if(item.psgType==3){
    // 				baby.amount+=1
    // 				baby.price=item.salePrice+item.airportFee+item.tax+item.serviceFee+(this.details.bxPrice?this.details.bxPrice/cxr.length:0)
    // 			}
    // 		})
    // 		if(!first.salePrice){
    // 			first=cxr[0]
    // 		}
    // 		adult.show=adult.amount>0
    // 		child.show=child.amount>0
    // 		baby.show=baby.amount>0
    // 		arr=[
    // 			adult,child,baby,
    // 			{name:'机票',price:first.salePrice,amount:cxr.length,unit:'/人'},
    // 			{name:'机建',price:first.airportFee,amount:cxr.length,unit:'/人'},
    // 			{name:'燃油税',price:first.tax,amount:cxr.length,unit:'/人'},
    // 			{name:'保险',price:this.details.bxPrice?this.details.bxPrice/cxr.length:0,amount:`/ ${this.checkBxList.length}份`,unit:''},
    // 			{name:'服务费',price:first.serviceFee,amount:cxr.length,unit:'/人'}
    // 		]
    // 	}
    // 	return arr
    // },
  },
  created () {
    this.orderId=this.$route.query.orderId
    this.getDetail()
  },
  methods:{
    getDetail(){
      this.$api['airService/orderDetail']({orderId:this.orderId}).then((res) => {
        let cache=res.data||{}
        this.detail=cache
        if(cache.isAutoCancle ==1){
          this.times=cache.autoCancleTime
        }
        // let layter= getPreStrTime(cache.bookDate,1)
        // let times=getDiffMinutes(formatDate(new Date()).datehms,layter)
        // if(times<=60&&times>1){
        // 	this.times=times*60*1000
        // }
      })
    },
    cancel(){
      this.$dialog.confirm({
        title:'提示',
        message:'确认取消订单？'
      }).then(()=>{
        this.$api['airService/cancel']({orderId:this.orderId,version:this.detail.version,orderFrom:this.sysType}).then((res) => {
          this.$dialog.alert({
            title:'提示',
            message:'订单已取消！'
          }).then(()=>{
            this.getDetail()
          })
        })
      })
    },
    pay(){
      this.$router.push({path:'/pay/payment',query:{orderType:'11028',orderId:this.orderId}})
    },
    showQr(index){
      this.qrInfo=this.detail.obtAirportServerOrderPsgBeanList[index]
      this.isShowQr=true
    }
  },
  watch: {
  },
  filters:{
    orderStatus:function(type){
      var obj={'1':'已预订','2':'已调度','3':'已出票','4':'已完成','5':'已取消'}//1标准
      return obj[type]||''
    },
    usageStatus:function(type){
      var obj={'1':'未使用','2':'已使用','3':'已过期'}
      return obj[type]||''
    },
    setOutModel:function(type){
      var obj={'0':'国内出发/国际出发','1':'国内出发','2':'国内到达','3':'国际出发','4':'国际到达'}
      return obj[type]||''
    }
  }
}
</script>

<style lang="less" scoped>
.mainbox{
    padding: 0 8px 50px;
}
.list{
    padding: 10px;
}
.box{
    padding-bottom: 5px;
}
    .wrapper {
        height: calc(100vh - 96px);
        overflow: hidden;
    }
</style>
